import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.916 3.381a8.06 8.06 0 0 1 8.782 1.747.75.75 0 0 0 1.06-1.06 9.555 9.555 0 0 0-13.517 0 .75.75 0 0 0 1.061 1.06 8.1 8.1 0 0 1 2.614-1.747M7 5.61a5.53 5.53 0 0 0-3.92 1.63.75.75 0 0 1-1.063-1.058 7.026 7.026 0 0 1 9.966 0 .75.75 0 0 1-1.064 1.058A5.53 5.53 0 0 0 7 5.61m-.98 2.939a2.59 2.59 0 0 1 2.867.58.75.75 0 1 0 1.075-1.047 4.094 4.094 0 0 0-5.866 0A.75.75 0 1 0 5.17 9.13c.242-.248.531-.446.85-.58m-.612 3.164a1.592 1.592 0 1 1 3.184 0 1.592 1.592 0 0 1-3.184 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const computerDeviceNetworkWifiConnection = { render };
export {
  computerDeviceNetworkWifiConnection as default,
  render
};
//# sourceMappingURL=computer-device-network-wifi-connection.svg.js.map
